import { createFileRoute } from '@tanstack/react-router';
import { TaskRulesPage } from '@/features/tasks/admin/TaskRulesPage';

/**
 * Regole dei task — la faccia scrivibile di `tenant-settings` (BE `v1.200.0`, task 1687 F4).
 *
 * Sta accanto a **Flussi di lavorazione** e **Configurazione bacheca**, e non per comodità di
 * menu: il flusso dice quali stati esistono, la bacheca come si vedono, e questa che cosa
 * succede quando si chiude un padre, quanto si annida l'albero e quando lo scostamento diventa
 * un avviso. Chi cerca «perché il task si comporta così» passa da una delle tre.
 *
 * ## ⚠️ Lo stesso componente è anche una sezione, e le due porte non sono un errore
 *
 * Dal 02-10-2026 `TaskRulesPage` si monta anche in «Regole di lavoro → Regole task», incorporata.
 * Non è una duplicazione: le due rispondono a due domande diverse, e si vede dal **selettore**.
 *
 * · **qui**, pagina di piattaforma: si sceglie su quale azienda del proprio ramo lavorare. È il
 *   posto di chi amministra più aziende e vuole confrontarle o sistemarne una senza entrarci;
 * · **nella sezione**: l'azienda è quella in cui si è entrati, e il selettore non c'è — lo vieta
 *   la regola 18, e lo toglie `pinnedCompany`. È il posto di chi sta configurando *questa*
 *   azienda e trova le regole dei task accanto a tutte le altre regole.
 *
 * Quel che non deve succedere è che divergano: il componente è **uno solo**, e la differenza è un
 * parametro. Due copie sarebbero due schermate che fra un mese dicono cose diverse.
 */
export const Route = createFileRoute('/_app/admin/task-rules')({ component: TaskRulesPage });
